import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { CandidateNote } from './note.interface';
export class CandidateNoteService {
   async post(id: number, note: CandidateNote) {
      const response = await http.post<ApiResource<CandidateNote>>(`/candidates/${id}/notes`, note);
      return response.data;
   }
   async delete(candidate_id: number, id: number) {
      const response = await http.delete<ApiResource<CandidateNote>>(`/candidates/${candidate_id}/notes/${id}`);
      return response.data;
   }
   async put(id: number, noteId: number, note: CandidateNote) {
      const response = await http.put<ApiResource<CandidateNote>>(`/candidates/${id}/notes/${noteId}`, note);
      return response.data;
   }
}
